module.exports = __webpack_public_path__ + "img/edt di.bceff3f1.svg";